exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".custom-banner {\n  height: 30px;\n  line-height: 30px;\n  overflow: hidden;\n  padding: 0 10px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

